// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Failed = function Failed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.571 2.929a.645.645 0 0 0-.642.642V16.43c0 .353.289.642.642.642H16.43c.353 0 .642-.289.642-.642V3.57a.645.645 0 0 0-.642-.642zM1 3.57A2.574 2.574 0 0 1 3.571 1H16.43A2.574 2.574 0 0 1 19 3.571V16.43A2.574 2.574 0 0 1 16.429 19H3.57A2.574 2.574 0 0 1 1 16.429zm5.746 3.175a.96.96 0 0 1 1.362 0l1.888 1.888 1.888-1.888a.964.964 0 0 1 1.362 1.362l-1.888 1.888 1.888 1.888a.964.964 0 0 1-1.362 1.362l-1.888-1.888-1.888 1.888a.964.964 0 0 1-1.362-1.362l1.888-1.888-1.888-1.888a.96.96 0 0 1 0-1.362"
  }));
};
